import { timeInMinutes } from './time-in-minutes';

/**
 * Takes start and end time in string format (hh:mm)
 * Returns the number of minutes between
 */
export function durationInMinutes(start: string, end: string): number {
  if (start && end) {
    return timeInMinutes(end) - timeInMinutes(start);
  }
  return 0;
}
